export const featuredStories = [
  {
    id: 'feat-1',
    title: '商场同框被拍，双方经纪人当晚先后回应',
    summary: '两人被拍到一前一后进入同一商场，随行有工作人员。双方经纪人均表示属朋友聚会，呼吁理性看待。',
    category: '明星绯闻',
    time: '2 小时前',
    image:
      'https://readdy.ai/api/search-image?query=cinematic%20moody%20editorial%20photograph%20of%20a%20city%20mall%20entrance%20at%20night%20with%20warm%20crimson%20signage%20and%20blurred%20crowd%2C%20dramatic%20contrast%20and%20soft%20film%20grain%2C%20stylized%20abstract%20urban%20scene&width=800&height=600&seq=featured-mall-night-01&orientation=landscape',
    tags: ['明星绯闻', '官方回应'],
  },
  {
    id: 'feat-2',
    title: '直播间售后争议持续，平台介入核实订单',
    summary: '围绕赠品规格的讨论仍在继续，平台方面表示会依据订单记录核实，主播团队称将逐一处理售后。',
    category: '网红黑料',
    time: '3 小时前',
    image:
      'https://readdy.ai/api/search-image?query=cinematic%20moody%20editorial%20photograph%20of%20a%20streaming%20room%20with%20warm%20amber%20ring%20light%20and%20blurred%20product%20boxes%2C%20dramatic%20contrast%20and%20soft%20film%20grain%2C%20stylized%20abstract%20ecommerce%20scene&width=800&height=600&seq=featured-live-room-02&orientation=landscape',
    tags: ['网红黑料', '售后争议'],
  },
  {
    id: 'feat-3',
    title: '综艺名场面复盘：那段互动到底发生了什么',
    summary: '节目播出后相关片段被反复剪辑传播，我们按时间顺序还原现场环节，并标注了节目组的原始剪辑。',
    category: '吃瓜现场',
    time: '4 小时前',
    image:
      'https://readdy.ai/api/search-image?query=cinematic%20moody%20editorial%20photograph%20of%20a%20colorful%20variety%20show%20stage%20with%20warm%20red%20and%20gold%20lights%20and%20blurred%20cameras%2C%20dramatic%20contrast%20and%20soft%20film%20grain%2C%20stylized%20abstract%20studio%20scene&width=800&height=600&seq=featured-variety-stage-03&orientation=landscape',
    tags: ['吃瓜现场', '综艺话题'],
  },
  {
    id: 'feat-4',
    title: '巡演预热页面流出，主办方提醒认准官方渠道',
    summary: '票务平台出现尚未开放的页面截图，主办方回应称最终信息以官方公告为准，提醒注意购票安全。',
    category: '演出动态',
    time: '5 小时前',
    image:
      'https://readdy.ai/api/search-image?query=cinematic%20moody%20editorial%20photograph%20of%20an%20empty%20concert%20stage%20with%20warm%20amber%20spotlights%20and%20fog%2C%20dramatic%20contrast%20and%20soft%20film%20grain%2C%20stylized%20abstract%20live%20music%20scene&width=800&height=600&seq=featured-tour-stage-04&orientation=landscape',
    tags: ['演出动态', '购票提醒'],
  },
  {
    id: 'feat-5',
    title: '剧集物料排序变化，观众逐帧对比找出差异',
    summary: '有观众把新旧海报放在一起比较，指出署名顺序与主视觉元素均有微调，片方暂未公开说明。',
    category: '片场花絮',
    time: '6 小时前',
    image:
      'https://readdy.ai/api/search-image?query=cinematic%20moody%20editorial%20photograph%20of%20a%20backlit%20film%20poster%20wall%20in%20warm%20crimson%20light%20with%20blurred%20figures%2C%20dramatic%20contrast%20and%20soft%20film%20grain%2C%20stylized%20abstract%20cinema%20scene&width=800&height=600&seq=featured-film-poster-05&orientation=landscape',
    tags: ['片场花絮', '番位争议'],
  },
  {
    id: 'feat-6',
    title: '内容搬运争议升级：原作者补充对比材料',
    summary: '原作者再次晒出草稿与分镜细节，涉事博主维持独立创作说法，双方均表示愿意继续沟通。',
    category: '网红黑料',
    time: '7 小时前',
    image:
      'https://readdy.ai/api/search-image?query=cinematic%20moody%20editorial%20photograph%20of%20a%20dark%20desk%20covered%20with%20storyboard%20sketches%20under%20warm%20amber%20lamp%20light%2C%20dramatic%20contrast%20and%20soft%20film%20grain%2C%20stylized%20abstract%20creative%20scene&width=800&height=600&seq=featured-storyboard-desk-06&orientation=landscape',
    tags: ['网红黑料', '原创争议'],
  },
  {
    id: 'feat-7',
    title: '见面会改期后续：退改签说明已补充发布',
    summary: '主办方在原公告评论区补充了退改签流程，粉丝关心的座位保留问题也在说明中作出回应。',
    category: '演出动态',
    time: '8 小时前',
    image:
      'https://readdy.ai/api/search-image?query=cinematic%20moody%20editorial%20photograph%20of%20an%20empty%20event%20hall%20with%20warm%20amber%20ceiling%20lights%20and%20rows%20of%20seats%2C%20dramatic%20contrast%20and%20soft%20film%20grain%2C%20stylized%20abstract%20venue%20scene&width=800&height=600&seq=featured-fanmeeting-hall-07&orientation=landscape',
    tags: ['演出动态', '行程变动'],
  },
  {
    id: 'feat-8',
    title: '同框传闻温度回落，网友整理“待确认清单”',
    summary: '随着时间推移，讨论焦点转向信息核实。有博主列出已知与待确认条目，提醒不要过度解读画面。',
    category: '明星绯闻',
    time: '10 小时前',
    image:
      'https://readdy.ai/api/search-image?query=cinematic%20moody%20editorial%20photograph%20of%20a%20rainy%20night%20window%20with%20warm%20crimson%20city%20bokeh%20outside%2C%20dramatic%20contrast%20and%20soft%20film%20grain%2C%20stylized%20abstract%20mood%20scene&width=800&height=600&seq=featured-night-window-08&orientation=landscape',
    tags: ['明星绯闻', '理性吃瓜'],
  },
  {
    id: 'feat-9',
    title: '片场路透解读：新剧造型与设定信息整理',
    summary: '网友在拍摄地附近拍到新剧路透，我们从公开物料中整理了已知的角色设定与服装风格，未作额外推测。',
    category: '片场花絮',
    time: '12 小时前',
    image:
      'https://readdy.ai/api/search-image?query=cinematic%20moody%20editorial%20photograph%20of%20a%20film%20set%20at%20night%20with%20warm%20amber%20floodlights%20and%20blurred%20equipment%2C%20dramatic%20contrast%20and%20soft%20film%20grain%2C%20stylized%20abstract%20production%20scene&width=800&height=600&seq=featured-filmset-night-09&orientation=landscape',
    tags: ['片场花絮', '路透解读'],
  },
];